import { Nullable } from "@core/domain/types/nullable.type";
import { Nullish } from "@core/domain/types/nullish.type";
import { EntitySummaryDto } from "@entity/data/dto/entities-summary.dto";
import { EntitySummary } from "@entity/domain/models/entity-summary.model";
import { TypologyEnum } from "@entity/domain/models/typology.model";
import { validateSync } from "class-validator";
import { inject, injectable } from "inversify";
import { TypologyEnumMapper } from "./typology-enum.mapper";

@injectable()
export class EntitySummaryMapper {
    constructor(
        @inject(TypologyEnumMapper)
        private readonly typologyEnumMapper: TypologyEnumMapper,
    ) {}
    map(entitySummaryDto: EntitySummaryDto): Nullable<EntitySummary> {
        const errors = validateSync(entitySummaryDto);

        if (Boolean(errors.length)) {
            console.error(errors);

            return null;
        }

        let typology: Nullish<TypologyEnum> = undefined;

        if (entitySummaryDto.legal_typology) {
            typology = this.typologyEnumMapper.map(
                entitySummaryDto.legal_typology,
            );
        }

        if (typology === null) return null;

        return new EntitySummary(
            entitySummaryDto.id,
            entitySummaryDto.company_name,
            entitySummaryDto.identification ?? undefined,
            typology,
            entitySummaryDto.legal_typology_label ?? undefined,
        );
    }
}
